import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/jobs/$jobId')({
  ssr: false, // CSR only - no SEO needed
})
